import { useAuthContext } from "src/auth/hooks";
import { MENU_TITLES, PAGE_TITLES } from "src/commons/const/titles";
import Iconify from "src/components/iconify/iconify";
import { useRouter } from "src/routes/hooks";
import { paths } from "src/routes/paths";

// ----------------------------------------------------------------------

export function useNavData() {
  const { logout } = useAuthContext();
  const router = useRouter();

  const handleLogout = () => {
    logout();
    router.push(paths.auth.login);
  };

  const data = [
    {
      items: [
        {
          title: MENU_TITLES.users,
          path: paths.users.root,
          roles: [""],
          icon: <Iconify width={32} icon="carbon:user-multiple" />,
        },
        {
          title: MENU_TITLES.operations,
          path: paths.operations.root,
          roles: [""],
          icon: <Iconify width={32} icon="carbon:cics-system-group" />,
          children: [
            {
              title: PAGE_TITLES.operations.detail.suspendApp,
              path: paths.operations.detail.suspendApp,
            },
            {
              title: PAGE_TITLES.operations.detail.updateNotification,
              path: paths.operations.detail.updateNotification,
            },
            {
              title: PAGE_TITLES.operations.detail.termsReconsent,
              path: paths.operations.detail.termsReconsent,
            },
            {
              title: PAGE_TITLES.operations.detail.municipalityData,
              path: paths.operations.detail.municipalityData,
            },
          ],
        },
        {
          title: MENU_TITLES.pushNotifications,
          path: paths.pushNotifications.root,
          roles: [""],
          icon: <Iconify width={32} icon="carbon:notification" />,
        },
        {
          title: MENU_TITLES.accountManagement,
          path: paths.accountManagement.root,
          roles: [""],
          icon: <Iconify width={32} icon="carbon:id-management" />,
        },
      ],
    },
  ];

  return data;
}
